import { DownOutlined, FolderOpenTwoTone, LoadingOutlined, SaveOutlined } from '@ant-design/icons';
import { Button, Col, Row, Select, Spin, Table, Tree } from 'antd';
import Column from 'antd/es/table/Column';
import type { DataNode } from 'antd/es/tree';
import { Tabs } from 'antd/lib';
import { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { ContentHeader } from "../../components";
import ModalTextForm from '../../components/modal/ModalTextForm';
import { idQuyDauTu, loaiLanhDaoPhuTrach } from '../../constants';
import { NhanVienResponse } from '../../models/nhanvien/NhanVien';
import { LanhDaoPhuTrachPhongRequest } from '../../models/setting/Setting';
import { LayDSDonViPhuTrachTheoIdNhanVien, layDanhSachDonViTreeView } from '../../services/donvi';
import { layDanhSachPhoGiamDocPhuTrach, luuLanhDaoPhuTrachPhong } from '../../services/setting';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const loaiPhuTrachOptions = [
    { value: loaiLanhDaoPhuTrach.phuTrach1, label: 'PGĐ phụ trách' },
    { value: loaiLanhDaoPhuTrach.phuTrach2, label: 'PGĐ phụ trách lĩnh vực' },
];

const convertNhanVienTreeView = (data: any) => {
    let nhanVienArr: Array<DataNode> = [];
    if (data) {
        nhanVienArr = data.map((_item: any) => {
            let rs: DataNode = {
                key: "0"+_item?.id,
                title: _item?.hoTen + " - " + _item?.tenChucVu
            }
            return rs;
        })
    }
    return nhanVienArr;
}

const convertDataTreeView = (data: any) => {
    let chidlrenArr: Array<DataNode> = [];
    if (data) {
        chidlrenArr = data.map((_item: any) => {
            let rs: DataNode = {
                key: _item?.id,
                title: _item?.ten,
                icon: <FolderOpenTwoTone style={{ fontSize: "20px" }} />,
                children: [...convertNhanVienTreeView(_item?.nhanViens), ...convertDataTreeView(_item?.children)]
            }
            return rs;
        })
    }
    return chidlrenArr;
}

const PhoGiamDocPhuTrach = () => {
    const [nhanVienSelected, setNhanVienSelected] = useState<any>();
    const [openModalSave, setOpenModalSave] = useState<boolean>(false);
    const [loadingTree, setLoadingTree] = useState<boolean>(false);
    const [allSelectedKeys, setAllSelectedKeys] = useState<Array<any>>([]);
    const [loaiPhuTrachMap, setLoaiPhuTrachMap] = useState<Record<number, number>>({});
    const [treeData, setTreeData] = useState<Array<DataNode>>([]);
    const [nhanViens, setNhanViens] = useState<any>([]);
    const [isLoadingTable, setIsLoadingTable] = useState<boolean>(false);
    const [dataTable, setDataTable] = useState<Array<NhanVienResponse>>([]);
    const dispatch = useDispatch();

    const onCheckTree = (checkedKeysValue: any) => {
        setAllSelectedKeys(checkedKeysValue.checked || []);
    };  

    const layDsDonViTheoNhanVienSelected = async () => {
        if (!nhanVienSelected?.key) {
            setAllSelectedKeys([idQuyDauTu]);
            setLoaiPhuTrachMap({});
            return;
        }
        setLoadingTree(true);
        try {
            let fOU = await LayDSDonViPhuTrachTheoIdNhanVien(nhanVienSelected.id);
            var data = fOU.map((item: any, index) => { item.key = index + item.id; return item });

            setAllSelectedKeys([...data.map(x => x.id)]);

            const map: Record<number, number> = {};
            data.forEach((x: any) => { map[x.id] = x.loai || loaiLanhDaoPhuTrach.phuTrach1; });
            setLoaiPhuTrachMap(map);
        } catch (ex: any) {
            toast.error(ex);
        }

        setLoadingTree(false);
    }


    useEffect(() => {
        const NVTree = convertDataTreeView(nhanViens);
        setTreeData(NVTree);
    }, [nhanViens]);

    useEffect(() => {
        layDsNvTheoDonVi();
        layDsPGDPhuTrach();
    }, []);

    useEffect(() => {
        layDsDonViTheoNhanVienSelected();
    }, [nhanVienSelected]);


    const layDsNvTheoDonVi = async () => {
        try {
            setLoadingTree(true);
            let data = await layDanhSachDonViTreeView();
            let idDonVis = data.flatMap(({ id, children }) => [id,...children?.map(({id})=>id)||[]]);
            setAllSelectedKeys(idDonVis);
            setNhanViens(data);
        } catch (error: any) {
            toast.error(error);
        };
        setLoadingTree(false);
    }

    const layDsPGDPhuTrach = async () => {
        try {
            setIsLoadingTable(true);
            let temp = await layDanhSachPhoGiamDocPhuTrach();
            var data = temp.map((item: any) => { item.key = item.id; return item });
            setDataTable(data);
        } catch (error: any) {
            toast.error(error);
        };
        setIsLoadingTable(false);
    }

    const onSave = async () => {
        dispatch(showLoadingScreen());
        var request: LanhDaoPhuTrachPhongRequest = {
            idNhanVien: nhanVienSelected.id,
            loaiPhuTrachs: allSelectedKeys.map((id: number) => ({
                idDonVi: id,
                loai: loaiPhuTrachMap[id] ?? loaiLanhDaoPhuTrach.phuTrach1
            }))
        }
        var rs = await luuLanhDaoPhuTrachPhong(request);
        if (rs) {
            toast.success('Cập nhật thông tin thành công')
        }
        else {
            toast.error('Cập nhật thông tin không thành công')
        }
        dispatch(hideLoadingScreen());
    }

    return (
        <section>
        <ModalTextForm
            show={openModalSave}
                title="Cấu hình Phó giám đốc phụ trách phòng ban"
            handleClose={() => setOpenModalSave(false)}
            handleSave={async () => {
                await onSave()
                setOpenModalSave(false)
            }}
        >
            <p>Bạn có xác nhận lưu không?</p>
        </ModalTextForm>
        <ContentHeader title="Cấu hình Phó giám đốc phụ trách" />
            <Row gutter={16}>
                <Col span={12}>
                    <Tabs defaultActiveKey="1"
                        items={[{
                            key: '1',
                            label: 'Danh sách Phó giám đốc',
                            children:
                                <div className="card">
                                    <div className="card-primary">
                                        <Table
                                            dataSource={dataTable}
                                            loading={isLoadingTable}
                                            locale={{ emptyText: "Không có dữ liệu" }}
                                            rowKey="id"
                                            onRow={(record) => {
                                                return {
                                                    onClick: () => {
                                                        if (record?.id === nhanVienSelected?.id) {
                                                            setNhanVienSelected(null);
                                                        } else {
                                                            setNhanVienSelected(record);
                                                        }
                                                    },
                                                };
                                            }}
                                            rowClassName={(record) => {
                                                return (record?.id === nhanVienSelected?.id) ? "selected-row row-key-" : "";
                                            }}
                                        >
                                            <Column title="Tên nhân sự" width="34%" dataIndex="hoTen" key="hoTen" />
                                            <Column title="Phòng ban" width="33%" dataIndex="tenDonVi" key="tenDonVi" />
                                            <Column title="Chức vụ" width="33%" dataIndex="tenChucVu" key="tenChucVu" />
                                        </Table>
                                    </div>
                                </div>
                        }]}>
                    </Tabs>
                </Col>
                <Col span={12}>
                    <Tabs defaultActiveKey="1"
                        tabBarExtraContent=
                        {
                            nhanVienSelected?.id ?
                                <Button
                                    type="primary"
                                    icon={<SaveOutlined />}
                                    onClick={() => setOpenModalSave(true)}
                                > Lưu
                                </Button> : <></>
                        }
                        items={[{
                            key: '1',
                            label: 'Danh sách phòng ban',
                            children:
                                <div className="card card-body">
                                    <Row>
                                        <Col span="24">
                                            {loadingTree ?
                                                <Spin indicator={antIcon} />
                                                : <div id="treeView">
                                                    <Tree
                                                        checkable={nhanVienSelected?.key ? true : false}
                                                        checkedKeys={allSelectedKeys || []}
                                                        showIcon
                                                        showLine
                                                        multiple
                                                        switcherIcon={<DownOutlined />}
                                                        treeData={treeData}
                                                        onCheck={onCheckTree}
                                                        checkStrictly
                                                        blockNode
                                                        defaultExpandedKeys={[...allSelectedKeys, idQuyDauTu]}
                                                        titleRender={(node: any) => {
                                                            const isDonVi = typeof node.key === 'number';
                                                            const isChecked = allSelectedKeys.includes(node.key);
                                                            const showLoai = isDonVi && nhanVienSelected?.key && isChecked;
                                                            const loai = loaiPhuTrachMap[node.key] ?? loaiLanhDaoPhuTrach.phuTrach1;
                                                            return (
                                                                <span className="phu-trach-node">
                                                                    <span className="phu-trach-node__title">{node.title}</span>
                                                                    {showLoai &&
                                                                        <Select
                                                                            size="small"
                                                                            className={`phu-trach-node__select phu-trach-node__select--${loai === loaiLanhDaoPhuTrach.phuTrach1 ? 'chinh' : 'phu'}`}
                                                                            popupMatchSelectWidth={false}
                                                                            value={loai}
                                                                            options={loaiPhuTrachOptions}
                                                                            onClick={(e) => e.stopPropagation()}
                                                                            onChange={(val) => setLoaiPhuTrachMap(prev => ({ ...prev, [node.key]: val }))}
                                                                        />
                                                                    }
                                                                </span>
                                                            );
                                                        }}
                                                    />
                                                </div>
                                            }
                                        </Col>
                                    </Row>
                                </div>
                        }]}>
                    </Tabs>
                </Col>
            </Row>
        </section>
        )
};

export default PhoGiamDocPhuTrach;